"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var JackpotTypes_1 = require("../../interfaces/JackpotTypes");
var Amount_1 = __importDefault(require("../Amount/Amount"));
var TimeBased_1 = __importDefault(require("./components/TimeBased/TimeBased"));
var TextBelow = function (props) {
    var _a = props.feature, currency = _a.currency, _b = _a.featureData, jackpotType = _b.jackpotType, startTime = _b.startTime, endTime = _b.endTime, dropAmount = _b.dropAmount, featureLengthType = props.featureLengthType;
    var component;
    if (jackpotType === JackpotTypes_1.JackpotType.AmountLimit) {
        component = (0, jsx_runtime_1.jsx)(Amount_1.default, { currency: currency, amount: dropAmount });
    }
    if (jackpotType === JackpotTypes_1.JackpotType.HourlyJackpot || jackpotType === JackpotTypes_1.JackpotType.DailyJackpot) {
        component = (0, jsx_runtime_1.jsx)(TimeBased_1.default, { startTime: startTime, endTime: endTime });
    }
    if (!component) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-below ".concat(featureLengthType) }, { children: component }));
};
exports.default = TextBelow;
